/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
export { PlatformLocation, LOCATION_INITIALIZED } from './platform_location';
export { LocationStrategy, APP_BASE_HREF } from './location_strategy';
export { HashLocationStrategy } from './hash_location_strategy';
export { PathLocationStrategy } from './path_location_strategy';
export { Location } from './location';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/common/src/location/index.js
// module id = 598
// module chunks = 3